import {Injectable} from '@angular/core';
import {AddressComponent, CountryCode} from '../models/index';
import {AngularGooglePlaceConstantService} from '../constants/index';
export class AngularGooglePlaceService {
/**
 * @param {?} constant
 */
constructor(public constant: AngularGooglePlaceConstantService) {
  }
/**
 * @param {?} address_components
 * @param {?} query
 * @param {?=} val
 * @return {?}
 */
private find(address_components: Array<AddressComponent>, query: string, val: string = null) {

    for (const /** @type {?} */ attr of address_components) {
      for (const /** @type {?} */ type of attr.types) {
        if (type === query) {
          return val ? ( /** @type {?} */((<any>attr)))[val] : attr;
        }
      }
    }
    return null;
  }
/**
 * @param {?} address_components
 * @return {?}
 */
street_number(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'street_number', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
street(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'route', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
city(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'locality', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
state(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'administrative_area_level_1', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
postal_code(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'postal_code', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
country(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'country', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
administrative_area_level_2(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'administrative_area_level_2', 'long_name');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
intersection(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'intersection');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
political(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'political');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
administrative_area_level_3(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'administrative_area_level_3');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
administrative_area_level_4(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'administrative_area_level_4');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
administrative_area_level_5(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'administrative_area_level_5');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
colloquial_area(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'colloquial_area');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
ward(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'ward');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality_level_1(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality_level_1');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality_level_2(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality_level_2');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality_level_3(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality_level_3');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality_level_4(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality_level_4');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
sublocality_level_5(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'sublocality_level_5');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
neighborhood(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'neighborhood');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
premise(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'premise');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
subpremise(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'subpremise');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
natural_feature(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'natural_feature');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
airport(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'airport');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
park(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'park');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
point_of_interest(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'point_of_interest');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
floor(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'floor');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
establishment(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'establishment');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
parking(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'parking');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
post_box(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'post_box');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
postal_town(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'postal_town');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
room(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'room');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
bus_station(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'bus_station');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
train_station(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'train_station');
  }
/**
 * @param {?} address_components
 * @return {?}
 */
transit_station(address_components: Array<AddressComponent>) {
    return this.find(address_components, 'transit_station');
  }
/**
 * @return {?}
 */
countryIsoCode(): CountryCode[] {
    return this.constant.countryIsoCode();
  }
/**
 * @return {?}
 */
typesOptions(): string[] {
    return this.constant.types_options();
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AngularGooglePlaceConstantService, },
];
}

function AngularGooglePlaceService_tsickle_Closure_declarations() {
/** @type {?} */
AngularGooglePlaceService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AngularGooglePlaceService.ctorParameters;
/** @type {?} */
AngularGooglePlaceService.prototype.constant;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
